import { ChangeEvent, useState } from 'react';
import S from './AlertAudioStyles';
import useGetFleetId from '../../../API/hooks/useGetFleetId';
import useGetRole from '../../../API/hooks/useGetRole';
import { Button } from '../../../components/ui/Button/Button';
import Modal from '../../../components/common/Modal/Modal';
import ItemsList from '../../../components/common/ItemsList/ItemsList';
import { FilterConfig } from '../../../components/common/DropdownFilter/types';
import useLocalStorage from '../../../API/hooks/useLocalStorage';
import { getLocalStorageKey } from '../../../utils/storageUtils';
import { audioSchemasPageFilters } from '../../../constants/FilterDefault';
import useGetCurrentPage from '../../../API/hooks/useGetCurrentPage';
import useGetAudioSchemas from '../../../API/hooks/devices/useGetAudioSchemas';
import AlertAudioItem from './AlertAudioItem';
import CreateSchemaModal from './CreateSchemaModal/CreateSchemaModal';
import ActivateFleetModal from './ActivateFleetModal/ActivateFleetModal';
import useGetAudioSchemaFleet from '../../../API/hooks/devices/useGetAudioSchemaFleet';

const SEARCH_CONFIG = [
  {
    type: 'sortBy',
    display: 'radio',
    options: [
      { name_ASC: 'Schema name: asc' },
      { name_DESC: 'Schema name: desc' },
    ],
  },
] as FilterConfig[];

function AlertAudio(): JSX.Element {
  const [filters, setFilters] = useLocalStorage(getLocalStorageKey('audio-schemas-filters'), audioSchemasPageFilters);
  const currentPage = useGetCurrentPage();
  const [modalCreateSchema, toggleModalCreateSchema] = useState(false);
  const [modalActivateFleet, toggleModalActivateFleet] = useState(false);
  const fleetId = useGetFleetId();
  const { data: audioSchemaFleet, isLoading } = useGetAudioSchemaFleet(fleetId);
  const fleetSchemaIsActive = audioSchemaFleet?.isActive as boolean;

  const {
    isFleetViewer,
    isFleetManager,
  } = useGetRole();

  const createSchema = (e: ChangeEvent<any>): void => {
    toggleModalCreateSchema(true);
  };

  const activateFleet = (e: ChangeEvent<any>): void => {
    toggleModalActivateFleet(true);
  };

  if (isFleetViewer || isFleetManager) {
    return (
      <S.Wrapper>
        <p className="error">No permissions to see or change setting!</p>
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <div className={!(isFleetViewer || isFleetManager) ? '' : 'hidden'}>
        <div className="btns">
          <Button type="button" onClick={createSchema} disabled={isFleetViewer || isFleetManager}>Create new schema</Button>
          <Button type="button" onClick={activateFleet} disabled={isFleetViewer || isFleetManager}>Fleet active status</Button>
        </div>
        <ItemsList
          entity="audio-schemas"
          fleetId={fleetId}
          filtersConfig={SEARCH_CONFIG}
          filters={filters}
          defaultFilters={audioSchemasPageFilters}
          setFilters={setFilters}
          // hasSearch
          getQuery={useGetAudioSchemas}
          curentPage={currentPage}
        >
          <AlertAudioItem />
        </ItemsList>
      </div>
      {modalCreateSchema && (
        <Modal
          title="Create new schema"
          state={modalCreateSchema}
          toggleState={toggleModalCreateSchema}
          settings={{
            minWidth: '500px',
          }}
        >
          <CreateSchemaModal onClose={() => toggleModalCreateSchema(false)} />
        </Modal>
      )}
      {modalActivateFleet && (
        <Modal
          title="Activate schema for fleet"
          state={modalActivateFleet}
          toggleState={toggleModalActivateFleet}
          settings={{
            minWidth: '500px',
          }}
        >
          <ActivateFleetModal isFleetActive={fleetSchemaIsActive} onClose={() => toggleModalActivateFleet(false)} />
        </Modal>
      )}
    </S.Wrapper>
  );
}

export default AlertAudio;
